<template>
  <div>
    <el-form
      :inline="true"
      label-position="top"
      @submit.prevent.native="refreshData()"
    >
      <el-form-item>
        <label slot="label">Flujo</label>
        <el-select v-model="input.flow">
          <el-option label="retro" value="retro"></el-option>
          <el-option
            label="callcenterRetro"
            value="callcenterRetro"
          ></el-option>
          <el-option label="olaRetro" value="olaRetro"></el-option>
          <el-option
            label="callcenterOlaRetro"
            value="callcenterOlaRetro"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <label slot="label">Fecha</label>
        <el-date-picker
          v-model="input.date"
          type="date"
          placeholder="Seleccionar fecha"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName">
      <el-tab-pane label="Coupon Funnel" name="coupon">
        <coupon-funnel-view :filter="filter"></coupon-funnel-view>
      </el-tab-pane>
      <el-tab-pane label="Ticket Funnel" name="ticket">
        <ticket-funnel-view :filter="filter"></ticket-funnel-view>
      </el-tab-pane>
    </el-tabs>
    <!--
    <br />
    <el-button type="danger" @click="truncate()">Truncate</el-button>
    -->
  </div>
</template>
<script>
// import axios from "axios";
import moment from "moment";
import TicketFunnelView from "./TicketFunnelView.vue";
import CouponFunnelView from "./CouponFunnelView.vue";

export default {
  components: {
    TicketFunnelView,
    CouponFunnelView
  },
  data() {
    return {
      activeName: "coupon",
      input: {
        flow: "retro",
        date: new Date()
      }
    };
  },
  computed: {
    filter() {
      return {
        flow: this.input.flow,
        startAt: moment(this.input.date)
          .startOf("day")
          .toDate(),
        endAt: moment(this.input.date)
          .endOf("day")
          .toDate()
      };
    }
  }
};
</script>
